import axios from 'axios';

import { digestMessage, generateRandomId, getCookie } from '@/components/tracking_third_party/utils/fbcap.utils';
import { TmCart } from '@/tscapi/model/cart';
import { isConsentCategoryDisabled } from '@/tscapi/utils/consent';
import { Cookie } from '@/tscapi/utils/cookie';
import { getApiBaseUrl } from '@/tscapi/utils/utils';
declare global {
    interface Window {
        ttq: any;
    }
}

type TiktokObject = {
    event_source: string;
    event_source_id: string; //pixel_code
    test_event_code?: string;
    data: {
        event: string;
        event_time: string;
        event_id: string; //orderId
        properties: {
            order_id: string;
            content_type: string;
            contents: {
                price: number;
                quantity: number;
                content_id: string;
                content_category?: string;
                content_name: string;
                brand: string;
            }[];
            currency: string;
            value: number; //total value of the order
            description?: string;
            event_id?: string;
        };
        user: {
            ttclid: string; //hashed click id
            email: string; //hashed email
            phone: string;
            external_id: string; //edpno
            ttp: string; // _ttp cookie
            ip: string;
            user_agent: string;
            locale: string;
        };
        page: {
            url: string;
            referrer: string;
        };
    }[];
};

document.addEventListener(
    'order-confirmed',
    function (e: CustomEvent) {
        console.log('Event: TT order-confirmed');
        tiktokCompleteOrderEvent(e?.detail?.OrderedCart);
    },
    false,
);

async function tiktokCompleteOrderEvent(eventDetails: any) {
    //if consent is not given, prevent fb event
    if (isConsentCategoryDisabled('targeting')) {
        return;
    }
    const url = getApiBaseUrl();
    const tiktokObject = await generateTiktokObject(eventDetails);
    const tiktokObject2 = await generateTiktokObject(eventDetails);
    tiktokObject2[0].eventData.data[0].event_id += 'zz';
    tiktokObject2[0].eventData.data[0].event = 'PlaceAnOrder';

    const axiosInstance = axios.create({
        baseURL: url,
        withCredentials: true,
        headers: {
            Authorization: 'Basic 567e407f-4bc5-463e-9c28-3ac2a2b333ec',
            'Content-Type': 'application/json',
        },
    });

    // server event
    try {
        const response = await axiosInstance.post('/tracking/v1/events/', tiktokObject);
        const response2 = await axiosInstance.post('/tracking/v1/events/', tiktokObject2);
    } catch (error) {
        console.log('Error sending TT conversion event:', error?.response?.data || error.message);
    }
    // pixel event
    try {
        window.ttq.instance('C8AKQ23G5HF9JD2HK3O0').identify({
            email: eventDetails.Buyer.Email.toLowerCase(),
            phone_number: eventDetails.Buyer.BillingAddress.DayPhone.toLowerCase(),
            external_id: await digestMessage(eventDetails.Buyer.CustomerNo.toString()),
        });
        tiktokObject[0].eventData.data[0].properties.event_id = eventDetails.OrderSummary.OrderNo;
        const ttqInstance = window.ttq.instance('C8AKQ23G5HF9JD2HK3O0');
        ttqInstance.track('CompletePayment', tiktokObject[0].eventData.data[0], {
            event_id: eventDetails.OrderSummary.OrderNo,
        });
        ttqInstance.track('PlaceAnOrder', tiktokObject2[0].eventData.data[0], {
            event_id: eventDetails.OrderSummary.OrderNo + 'zz',
        });
    } catch (e) {
        console.log('Error sending TT pixel conversion event');
    }
}

const ttclid = getCookie('ttclid'); // TikTok Click ID
const ttp = getCookie('_ttp'); //Cookie id

async function generateTiktokObject(cart: TmCart) {
    const cookie = new Cookie();
    const tiktokObject: TiktokObject = {
        event_source: 'web',
        event_source_id: 'C8AKQ23G5HF9JD2HK3O0', //tt pixel code
        data: [
            {
                event: 'CompletePayment',
                event_id: cart.OrderSummary.OrderNo,
                event_time: Math.floor(Date.now() / 1000).toString(),
                properties: {
                    order_id: cart.OrderSummary.OrderNo,
                    content_type: 'product_group',
                    contents: cart.CartLines.map((item) => ({
                        price: item.InCart.PriceUnit,
                        quantity: item.InCart.Quantity,
                        content_id: item.CartLineItem.ItemNo,
                        content_category:
                            cart.Products.find((x) => x.ItemNo == item.CartLineItem.ItemNo).ProductTypes[0] ?? '',
                        content_name: cart.Products.find((x) => x.ItemNo == item.CartLineItem.ItemNo).Name,
                        brand: cart.Products.find((x) => x.ItemNo == item.CartLineItem.ItemNo).Brand ?? '',
                    })),
                    currency: 'CAD',
                    value: cart.OrderSummary.GrandTotalAmount,
                },
                user: {
                    ttclid: ttclid ?? '',
                    email: await digestMessage(cart.Buyer.Email.toLowerCase()),
                    phone: await digestMessage(cart.Buyer.BillingAddress.DayPhone.toLowerCase()),
                    external_id: await digestMessage(cart.Buyer.CustomerNo.toString()),
                    ttp: ttp,
                    ip: cookie?.TscClientIP ?? '',
                    user_agent: window.navigator.userAgent || '',
                    locale: cookie?.Language.replace('_', '-'), // Modified BCP 47 language identifier
                },
                page: {
                    url: window.location.href,
                    referrer: window.location.host,
                },
            },
        ],
    };

    //add test code if exits
    if (window.tscConfig?.TiktokTestCode) {
        tiktokObject.test_event_code = window.tscConfig.TiktokTestCode;
    }

    return [{ eventConsumer: 'tiktok', eventData: { ...tiktokObject } }];
}
